module.exports = "<div class=\"users\">\n    <user [user]=\"user\" [notActions]=\"true\" [withToken]=\"true\"></user>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/my-profile/my-profile.component.html
// module id = 1750
// module chunks = 0